/**
 * This file is replaced in the 'npm run build:version' script.
 */
export const RXDB_VERSION = '17.3.0';
